import styled, { css } from 'styled-components';

const CarouselStyled = styled.div.attrs({ className: 'carousel' })`
  ${({ theme }) => {
    const { media } = theme;
    return css`
      width: 100%;

      .carousel {
        &__frame {
          overflow-x: hidden;
          padding: 16px 8px;
          margin: -16px -8px;
        }

        &__slide {
          display: flex;
        }

        &__controls {
          margin-top: 24px;
          align-items: center;
          display: flex;
          justify-content: center;
        }
      }

      .plan-card {
        min-width: 100%;
        &:not(:last-child) {
          margin-right: 8px;
        }

        ${media.tablet.down} {
          flex-direction: column;
        }
      }
    `;
  }}
`;

export default CarouselStyled;

export const ArrowButton = styled.button`
  ${({ theme }) => {
    const { colors } = theme;

    return css`
      background-color: transparent;
      border: none;
      box-shadow: none;
      width: auto;
      height: auto;
      padding: 0;

      &.hide {
        pointer-events: none;
        visibility: hidden;
      }
      .icon {
        fill: ${colors.primary.darkBlue};
        width: 70px;
        height: 59px;
      }
    `;
  }}
`;

export const Indicator = styled.div`
  ${({ selected, theme }) => {
    const { colors } = theme;
    return css`
      background-color: ${selected ? colors.primary.darkBlue : colors.primary.white};
      border-radius: 100%;
      border: 1px solid ${colors.primary.darkBlue};
      margin 0 8px;
      height: 11px;
      width: 11px;
    `;
  }}
`;
